<template>
  <div class="filters-selected">
    <div v-if="false" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.CompanyPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="company in selectedCompanies" :key="company.Id" type="is-primary is-small is-icon" :value="company.Id" @click="onSelectedCompanyRemove(company.Id)">
            <span>{{ company.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedChannelMetadataTypes.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Leads.ChannelMetadataPlaceholder") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button
            v-for="channelMetadataType in selectedChannelMetadataTypes"
            :key="channelMetadataType.Id"
            type="is-primary is-small is-icon"
            :value="channelMetadataType.Id"
            @click="onSelectedChannelMetadataTypeRemove(channelMetadataType.Id)"
          >
            <span>{{ channelMetadataType.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <div v-if="selectedSources.length" class="filters-selected-item">
      <span class="filters-selected-label">{{ $t("Phones.Grid.Columns.ChannelName") }}:</span>
      <span class="filters-selected-values">
        <div class="filters-selected-value">
          <b-button v-for="source in selectedSources" :key="source.Id" type="is-primary is-small is-icon" :value="source.Id" @click="onSelectedSourceRemove(source.Id)">
            <span>{{ source.Title }}</span>
            <icon-base width="7.71" height="7.71" view-box="0 0 7.71 7.71" icon-name="times-small">
              <icon-times-small />
            </icon-base>
          </b-button>
        </div>
      </span>
    </div>
    <b-button type="is-warning" size="is-small" class="reset-filters-btn" :label="$t('ResetFilters')"
      v-if="hasFilters"
      @click="resetFilters()" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { MultiselectItem } from "@/models/MultiselectItem";
import { AvailableChannelMetadataTypesMode } from "@/models/campaigns/ChannelType";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import { PhoneStatus } from "@/models/phones/PhoneWithChannel";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import PhoneService from "@/services/PhoneService";
import IconBase from "../IconBase.vue";
import IconTimesSmall from "../icons/IconTimesSmall.vue";

const namespace = "phonesModule";

@Component({
  components: {
    IconBase,
    IconTimesSmall,
  },
})
export default class PhonesFiltersSelected extends Vue {
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("datePeriod", { namespace }) datePeriod!: Date[];
  @Getter("phonesPageData", { namespace }) phonesPageData!: PhonesPageData;
  @Getter("selectedCallStatus", { namespace }) selectedCallStatus!: MetadataMaskyooStatus;
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Getter("selectedPhoneStatus", { namespace }) selectedPhoneStatus!: PhoneStatus;
  @Getter("selectedSourcesIds", { namespace }) selectedSourcesIds!: string[];
  @Getter("sources", { namespace }) sources!: MultiselectItem[];
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedCompaniesIds", { namespace }) setSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setSelectedSourcesIds", { namespace }) setSelectedSourcesIds!: (selectedSourcesIds: string[]) => void;

  get hasFilters(): boolean {
    return this.selectedCompanies.length > 0
          || this.selectedChannelMetadataTypes.length > 0
          || this.selectedSourcesIds.length > 0
          || !HelperService.compareDateArrays(this.datePeriod, HelperService.getThisMonthPeriod())
          || this.selectedCallStatus !== MetadataMaskyooStatus.All
          || this.selectedPhoneStatus !== PhoneStatus.Active;
  }

  get selectedChannelMetadataTypes(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads).filter((i: MultiselectItem) => this.selectedChannelMetadataTypesIds.indexOf(+i.Id) >= 0);
  }
  
  get selectedCompanies(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => this.selectedCompaniesIds.indexOf((i.Id as any) as number) >= 0);
  }

  get selectedSources(): MultiselectItem[] {
    return this.sources.filter((i: MultiselectItem) => this.selectedSourcesIds.indexOf(i.Id) >= 0);
  }

  onSelectedChannelMetadataTypeRemove(selectedChannelMetadataTypeId: number): void {
    const selectedChannelMetadataTypesIdsNew: number[] = this.selectedChannelMetadataTypesIds.filter((i) => i !== +selectedChannelMetadataTypeId);
    this.setSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIdsNew);
  }

  onSelectedCompanyRemove(selectedCompaniesId: number): void {
    const selectedCompaniesIdsNew: number[] = this.selectedCompaniesIds.filter((i) => i !== selectedCompaniesId);
    this.setSelectedCompaniesIds(selectedCompaniesIdsNew);
  }

  onSelectedSourceRemove(selectedSourceId: string): void {
    const selectedSourcesNew: string[] = this.selectedSourcesIds.filter((i) => i !== selectedSourceId);
    this.setSelectedSourcesIds(selectedSourcesNew);
  }

  resetFilters(): void {
    PhoneService.resetFilters(this.phonesPageData.CompanyId !== 0);
  }
}
</script>
